import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { MotivoRecusaDoOrcamento } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetBackofficeModal = {
  name: string,
  value: boolean,
}

type BackofficeModal = {
  motivoRecusaOrcamento: boolean,
}

@Module({ namespaced: true, name: 'BackofficeMotivoRecusaOrcamentoStore' })
export default class BackofficeMotivoRecusaOrcamentoStore extends VuexModule {
  public hospitalId: string = ''

  public mode: Mode = 'CREATE'

  public modal: BackofficeModal = {
    motivoRecusaOrcamento: false,
  }

  @Mutation
  setModal(modal: SetBackofficeModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: Mode) {
    this.mode = param
  }

  /** Motivo de recusa do orcamento */
  private motivoRecusaOrcamentoDefault: MotivoRecusaDoOrcamento = {
    id: '',
    descricao: '',
    hospitalId: '',
    status: 'Ativo',
  }

  public motivoRecusaOrcamento: MotivoRecusaDoOrcamento = { ...this.motivoRecusaOrcamentoDefault }
  private motivoRecusaOrcamentoListDefault: MotivoRecusaDoOrcamento[] = []
  public motivoRecusaOrcamentoList: MotivoRecusaDoOrcamento[] = [...this.motivoRecusaOrcamentoListDefault]
  public searchMotivoRecusaOrcamento: string = ''

  @Mutation
  setSearchMotivoRecusaOrcamento(value: string) {
    this.searchMotivoRecusaOrcamento = value
  }

  @Mutation
  setMotivoRecusaOrcamento(motivoRecusaOrcamento: MotivoRecusaDoOrcamento) {
    this.motivoRecusaOrcamento = { ...motivoRecusaOrcamento }
  }

  @Mutation
  clearMotivoRecusaOrcamento() {
    this.motivoRecusaOrcamento = { ...this.motivoRecusaOrcamentoDefault }
  }

  @Mutation
  setMotivoRecusaOrcamentoList(value: MotivoRecusaDoOrcamento[]) {
    this.motivoRecusaOrcamentoList = value
  }

  @Mutation
  clearMotivoRecusaOrcamentoList() {
    this.motivoRecusaOrcamentoList = [...this.motivoRecusaOrcamentoListDefault]
  }

  @Action
  async getMotivoDeRecusaDoOrcamentoByHospitalId() {
    try {
      const params: any = { hospitalId: this.hospitalId }
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMotivoDeRecusaDoOrcamentoByHospitalId(params)
      if (request.success) this.context.commit('setMotivoRecusaOrcamentoList', request.data as MotivoRecusaDoOrcamento[] || [])
      return request
    } catch (error) {
      this.context.commit('setMotivoRecusaOrcamentoList', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertMotivoDeRecusaDoOrcamento() {
    try {
      const params: any = { ...this.motivoRecusaOrcamento, hospitalId: this.hospitalId }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.upsertMotivoDeRecusaDoOrcamento(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
